


























import Vue from 'vue';

import { style } from '@/web/utils/stripe';
import auth from '@/core/api/modules/auth';

export default Vue.extend({
  data() {
    return {
      stripeCompleted: false,
      stripeError: false,
      inProgress: false,
    };
  },
  methods: {
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      this.card.mount(this.$refs['card-element']);
      this.card.addEventListener('change', this.stripeChangeCallback);
    },
    async changeCard() {
      this.inProgress = true;

      try {
        const setupIntent = await auth.meTeacherSetupIntent();
        const confirmCard = await this.stripe.confirmCardSetup(
          setupIntent.setup_intent.client_secret,
          { payment_method: { card: this.card } }
        );

        const data = {
          default_payment_method: confirmCard.setupIntent.payment_method,
        };
        await this.$store.dispatch('setting/getAccountSubscriptionInfo', data);

        this.$emit('close');
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t('SETTINGS.TEXT.PAYMENT_METHOD_CHANGE_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error?.response?.data,
        });
      }
      this.inProgress = false;
    },
  },
  mounted() {
    this.initStripe();
  },
});
